import { REQUIRED_MESSAGING_TEMPLATE_VARIABLES } from "@constants/messaging-template-default";
import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { FormattedMessagingTemplate } from "@idw-types/data/messaging-template";
import { getMessagingTemplateEmailSubjectData } from "@utils/messaging-template-util";
import { useMemo } from "react";
import styles from "./messaging-template-content-preview.less";
import { messagingTemplateContentStringRegex } from "@constants/messaging-template-constants";

type MessagingTemplateContentPreviewProps = {
    state: FormattedMessagingTemplate;
    selectedLanguage: LocaleTypes;
}

export const MessagingTemplateContentPreview = ({ state, selectedLanguage }: MessagingTemplateContentPreviewProps) => {
    const {
        shouldHaveSubjectVariable,
        subjectVariableValue,
        subjectVariableName
    } = useMemo(() => {
        return getMessagingTemplateEmailSubjectData(state.type, state.languageFiles[selectedLanguage]);
    }, [state.languageFiles, selectedLanguage, state.type]);

    const contentWithoutVariables = useMemo(() => {
        const matches = state.template.match(messagingTemplateContentStringRegex);

        let finalString = state.template;
        if (matches) {
            matches.forEach(match => {
                //@ts-ignore
                const splitVar = match.split(/!(.*)/s);
                if (splitVar && splitVar.length > 1) {
                    const variableName = splitVar[0].substring(3, splitVar[0].length - 1);
                    const variableValue = splitVar[1].substring(1, splitVar[1].length - 2);
                    let valueToDisplay = variableValue;

                    if (REQUIRED_MESSAGING_TEMPLATE_VARIABLES.includes(variableName)) {
                        valueToDisplay = `{{${variableName}}}`;
                    } else {
                        const fieldNames = variableName.split(".");
                        let shouldUseLanguageFileValue = true;
                        if (state.languageFiles[selectedLanguage] && fieldNames.length > 0) {
                            let finalObj = state.languageFiles[selectedLanguage];
                            fieldNames.forEach(fieldName => {
                                if (finalObj[fieldName]) {
                                    finalObj = finalObj[fieldName];
                                } else {
                                    shouldUseLanguageFileValue = false;
                                }
                            });

                            if (shouldUseLanguageFileValue) {
                                //necessary to use any here because finalObj starts as { [key:string]: any } but becomes string
                                valueToDisplay = finalObj as any;
                            }
                        }
                    }

                    finalString = finalString.replace(match, `<acronym title="${variableName}">${valueToDisplay}</acronym>`);
                }
            });
        }

        // add id prefix to each of the css styles for preview
        if (finalString.includes("<style")) {
            const startIndex = finalString.indexOf("<style");
            const endIndex = finalString.indexOf("</style>");

            if (endIndex > -1) {
                const styleContentWithStartTag = finalString.substring(startIndex, endIndex);
                const endOfStyleTagIndex = styleContentWithStartTag.indexOf(">");

                if (endOfStyleTagIndex > -1) {
                    const styleContentWithoutTags = styleContentWithStartTag.substring(endOfStyleTagIndex + 1);
                    finalString =
                        finalString.substring(0, startIndex + endOfStyleTagIndex + 1) +
                        ` #messaging-template-content-preview { ${styleContentWithoutTags} } ` +
                        finalString.substring(endIndex);
                }
            }
        }

        return finalString;
    }, [state.template, state.languageFiles, selectedLanguage]);

    return <div id="messaging-template-content-preview" className={styles.contentPreview}>
        {shouldHaveSubjectVariable && (
            <div className={styles.emailSubjectContainer}>
                {subjectVariableValue && (
                    <label className={styles.subjectLabel}>
                        { /* @ts-ignore */}
                        <acronym title={subjectVariableName}>{subjectVariableValue}</acronym>
                    </label>
                )}
                <label className={styles.fromLabel}>from: email.address@domain.com</label>
                <hr />
            </div>
        )}
        <div className={styles.emailContentContainer}>
            <div dangerouslySetInnerHTML={{ __html: contentWithoutVariables }} />
        </div>
    </div>
}